export function changeRootClass(className, state) {
  var element = document.documentElement;
  if (state && !element.classList.contains(className)) {
    element.classList.add(className);
  }
  if (!state) {
    element.classList.remove(className);
  }
}